import * as Icons from 'react-icons/fa';

/**
 * Komponen untuk render icon dari react-icons/fa berdasarkan string nama icon
 * @param {string} iconStr - Nama icon dari react-icons/fa (contoh: 'FaHome', 'FaUser', dll)
 * @param {object} props - Props tambahan untuk icon (size, color, className, dll)
 * @returns {JSX.Element|null} - Icon component atau null jika icon tidak ditemukan
 */
const IconRenderer = ({ iconStr, ...props }) => {
    if (!iconStr) {
        return null;
    }

    const IconComponent = Icons[iconStr];
    
    if (!IconComponent) {
        console.warn(`Icon "${iconStr}" tidak ditemukan di react-icons/fa`);
        return null;
    }

    return <IconComponent {...props} />;
};

export default IconRenderer;

